const API = '/api/cliente_servicios';

export const getClienteServicios = async (clienteId = null) => {
  const url = clienteId ? `${API}?cliente_id=${clienteId}` : API;
  const res = await fetch(url);
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al obtener servicios de clientes');
  }
  return await res.json();
};

export const guardarClienteServicio = async (data) => {
  const res = await fetch(API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al asignar servicio');
  }
  return await res.json();
};

export const actualizarClienteServicio = async (data) => {
  const res = await fetch(API, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al actualizar servicio contratado');
  }
  return await res.json();
};

export const eliminarClienteServicio = async (id) => {
  const res = await fetch(`${API}?id=${id}`, {
    method: 'DELETE'
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al eliminar asignación de servicio');
  }
  return await res.json();
};
